export default __webpack_public_path__ + "static/media/logotipo_ENG.b13a7ed5.jpg";